import { __spreadArray } from "tslib";
import persian from 'react-date-object/calendars/persian';
import gregorianEn from 'react-date-object/locales/gregorian_en';
import DateObject from 'react-date-object';
import gregorian from 'react-date-object/calendars/gregorian';
export var daysInMonthEn = function (date, dateFormat) {
    date.calendar = gregorian;
    date.locale = gregorianEn;
    var monthName = date.month.name;
    var month = date.month, year = date.year;
    var firstDayWeekDay = new DateObject({ date: "".concat(year, " ").concat(month, " 1"), calendar: gregorian }).weekDay.number;
    // Calculate the number of empty cells needed before the first day of the month
    var emptyCellsCount = (firstDayWeekDay + 7) % 7;
    var lastDayOfPreviousMonth = new DateObject({ date: "".concat(year, " ").concat(month - 1, " 31"), calendar: gregorian });
    // Calculate the empty days from the previous month
    var emptyDays = __spreadArray([], Array(emptyCellsCount), true).map(function (_, i) { return lastDayOfPreviousMonth.month.length - emptyCellsCount + i + 1; });
    // Create an array of day objects for the current month
    var currentMonthDays = Array.from({ length: date.month.length }, function (_, i) {
        var dayNumber = i + 1;
        var gregorianDate = new DateObject({ date: ("".concat(year, " ").concat(month, " ").concat(dayNumber)), calendar: gregorian }).format(dateFormat);
        var jalaliDate = new DateObject({ date: ("".concat(year, " ").concat(month, " ").concat(dayNumber)), calendar: gregorian }).convert(persian).format(dateFormat);
        return { day: dayNumber, gregorianDate: gregorianDate, jalaliDate: jalaliDate, disabled: false };
    });
    var allDays = __spreadArray(__spreadArray([], emptyDays.map(function (day) { return ({
        day: day,
        gregorianDate: new DateObject({ date: ("".concat(year, " ").concat(month, " ").concat(day)), calendar: gregorian }).format(dateFormat),
        jalaliDate: new DateObject({ date: ("".concat(year, " ").concat(month, " ").concat(day)), calendar: gregorian }).convert(persian).format(dateFormat),
        disabled: true
    }); }), true), currentMonthDays, true);
    return { monthName: monthName, month: month, days: allDays, year: year };
};
//# sourceMappingURL=days-in-month.en.js.map